import { createContext } from "react";

export const CandidateContext = createContext();